/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { CheckBoxConfig } from 'libs/sysque/shared/ui/src/lib/models/check-box-config';
import { PanelDetails } from '../../../models/panel-detail';
import { DxSelectBoxComponent } from 'devextreme-angular';
import { getMaxContentWidth } from '../../../../../../../shared/ui/src/lib/utils/common.utils';

@Component({
  selector: 'sysque-panel-system',
  templateUrl: './panel-system.component.html',
  styleUrls: ['./panel-system.component.scss'],
  standalone: false
})
export class PanelSystemComponent {
  @Input() checkBoxConfigs: CheckBoxConfig[];
  @Input() addFittingMode: boolean;
  @Input() panelsList: PanelDetails[];
  @Output() panelValueChanged: EventEmitter<any> = new EventEmitter<string[]>();
  @Output() checkedCircuit: EventEmitter<any> = new EventEmitter<string[]>();
  @Output() panelFocusIn: EventEmitter<any> = new EventEmitter<string[]>();
  @ViewChild(DxSelectBoxComponent) panelDxSelectBox: DxSelectBoxComponent;
  @ViewChild('panelBoxContainer', { read: ElementRef }) panelBoxContainer: ElementRef;
  @ViewChild('panelContainer') panelContainer: ElementRef;
  public items: PanelDetails= new PanelDetails();
  public calculatedWidth: string = 'auto'; // Dynamically calculated width
  public resizeObserver: ResizeObserver;

  @HostListener('document:click', ['$event'])

  public ngAfterViewInit(): void {
    this.setupResizeObserver();
    this.calculateMaxWidth();
  }

  public onPanelFrameDocumentClick(event: MouseEvent): void {
    if (this.panelDxSelectBox && this.panelDxSelectBox.opened) {
       const clickedInside = this.panelBoxContainer.nativeElement.contains(event.target);
       if (!clickedInside) {
         this.panelDxSelectBox.opened = false;
       }
     }
   }
  
  public onPanelValueChanged(e: any): void {
    this.items.PanelName = e.value.panelName;
    this.items.ProjectName = e.value.projectName;
    this.addFittingMode = false;
    this.panelValueChanged.emit(this.items);
  }

  public onFocusIn(): void {
    this.panelFocusIn.emit();
  }

  public getUpdatedCircuit(e: any): void {
    this.checkedCircuit.emit(e);
  } 

  private setupResizeObserver(): void {
    if (typeof ResizeObserver === 'undefined') {
      return;
    }
    this.resizeObserver = new ResizeObserver(() => {
      this.calculateMaxWidth();
    });

    if (this.panelContainer && this.panelContainer.nativeElement) {
      this.resizeObserver.observe(this.panelContainer.nativeElement);
    }
  }

  public calculateMaxWidth(): void {
    // Recalculate width based on content and container size
    if (this.panelsList && this.panelsList.length > 0) {
      this.calculatedWidth = this.getMaxContentWidth(this.panelsList.map((x) => x.ProjectName));
    }
  }

  private getMaxContentWidth(items: string[]): string {
    let maxWidth = Number(getMaxContentWidth(items));

    const selectBoxWidth = this.panelDxSelectBox?.instance?.element()?.getBoundingClientRect()?.width;

    if (maxWidth > selectBoxWidth) {
      return (selectBoxWidth + 200).toString();
    }

    // Return the maximum width with some padding
    return (maxWidth + 30).toString(); // Add padding if necessary
  }
}
